import React, { useEffect } from "react";
import { Sparkles } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import GradientMesh from "@/components/GradientMesh";
import WhatsNewTimeline from "@/components/WhatsNewTimeline";
import SEO from "@/components/SEO";
import { useReleaseNotes } from "@/hooks/useReleaseNotes";

export default function WhatsNewPage() {
  const { releases, markLatestSeen } = useReleaseNotes();

  // Opening this page marks the newest release as read for this user
  // (see useReleaseNotes -> localStorage postmoro_last_seen_release).
  useEffect(() => {
    markLatestSeen();
  }, [markLatestSeen]);

  return (
    <>
      <SEO
        title="What's New | Postmoro"
        description="See the latest Postmoro features, improvements, and bug fixes."
        path="/whats-new"
        noindex
      />
      <GradientMesh />
      <div className="space-y-6 pb-10" data-testid="whats-new-page">
        <PageHeader
          title={
            <span className="inline-flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-[color:var(--brand-primary)]" />
              What&apos;s New
            </span>
          }
          subtitle="The latest features, improvements, and fixes in Postmoro."
        />
        <WhatsNewTimeline releases={releases} />
      </div>
    </>
  );
}
